export const REFERRAL = {
  GET_REFERRAL_CONFIG: 'GET_REFERRAL_CONFIG',
  GET_REFERRAL_USER_CONFIG: 'GET_REFERRAL_USER_CONFIG',
  GET_REFERRER: 'GET_REFERRER',
  GET_REFEREES: 'GET_REFEREES',
  GET_COMPLETED_REFERRALS: 'GET_COMPLETED_REFERRALS',
  GET_USER_BY_REFERRAL_ID: 'GET_USER_BY_REFERRAL_ID',
}
